import React from "react";
import "./ticketDetail.style";
import { Grid } from "@mui/material";
import { NOT_APPLICABLE, REQUEST_STATE } from "../../../constants/originalState";
import parse from 'html-react-parser';

export interface IAppRequestProps {
  infoTicket: any;
  locale: any;
}

const AppRequest = (props: IAppRequestProps) => {
  const { infoTicket, locale } = props;
  const { variables, approvers } = infoTicket;
  const { json_storage } = variables;

  return (
    <>
      <Grid container>
        <Grid item xs={6} className="pr-20">
          <p className="ttl-col-desc">{locale?.requestedFor}</p>
          <p className="value-info" id="lbl-ticketdetail-requestfor">
            {!!infoTicket.requestFor ? infoTicket.requestFor : NOT_APPLICABLE}
          </p>
        </Grid>
        <Grid item xs={6} className="pr-20">
          <p className="ttl-col-desc">{locale?.email}</p>
          <p className="value-info" id="lbl-ticketdetail-email">
            {!!infoTicket.email ? infoTicket.email : NOT_APPLICABLE}
          </p>
        </Grid>
        {approvers?.length > 0 && (
          <Grid item xs={6} className="pr-20">
            <p className="ttl-col-desc">{locale?.approverInfo}</p>
            <p className="value-info" id="lbl-ticketdetail-email">
              {!!approvers[0]?.approver_email
                ? approvers[0]?.approver_email
                : NOT_APPLICABLE}
            </p>
          </Grid>
        )}
        <Grid item xs={6} className="pr-20">
          <p className="ttl-col-desc">{locale?.costCenter}</p>
          <p className="value-info" id="lbl-ticketdetail-cost_center">
            {!!json_storage?.cost_center
              ? json_storage?.cost_center
              : NOT_APPLICABLE}
          </p>
        </Grid>
        <Grid item xs={6}>
          <p className="ttl-col-desc">
            {locale?.business_justification_comments}
          </p>
          <p className="value-info" id="lbl-ticketdetail-business_justification_comments">
            {parse(json_storage?.business_justification || NOT_APPLICABLE)}
          </p>
        </Grid>
        {json_storage?.app_name && 
          <Grid container>
            <Grid item xs={12}>
              <p className="ttl-col-desc">{locale?.requestedItem}</p>
              <p className="value-info">{json_storage?.app_name || NOT_APPLICABLE}</p>
            </Grid>
          </Grid>
        }
        {approvers?.map((items: any) => items.state === REQUEST_STATE.REJECTED &&
          <Grid item xs={6} className="pr-20">
            <p className="ttl-col-desc">{locale?.rejectComment}</p>
            <p className="value-info" id="lbl-ticketdetail-comment">{items?.comments?.[0]?.comment}</p>
          </Grid>
        )}

      </Grid>
    </>
  );
};

export default AppRequest;